'use client';

import { ArrowUpRight } from 'lucide-react';
import Image from 'next/image';
import React from 'react';

export function HeroSection() {
  return (
    <section className="relative min-h-[85vh] lg:min-h-[90vh] bg-[#F8F9FA] text-neutral-900 flex flex-col pb-16 lg:pb-20 overflow-hidden">
      <div className="h-16 md:h-20 lg:h-24 shrink-0" />
      <div className="flex-1 flex items-center">
        {/* Background grid pattern */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `
            linear-gradient(to right, #000000 1px, transparent 1px),
            linear-gradient(to bottom, #000000 1px, transparent 1px)
          `,
            backgroundSize: '4rem 4rem',
          }}
        />

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col-reverse lg:grid lg:grid-cols-[1.1fr_1fr] gap-8 lg:gap-12 items-center">
          {/* Left Side: Copywriting */}
          <div className="max-w-2xl">
            <h1 className="text-fluid-3xl md:text-fluid-5xl lg:text-fluid-6xl font-bold tracking-tight leading-[1.05] mb-4 md:mb-6 text-neutral-900">
              Mengurai Kompleksitas <br />
              <span className="text-neutral-500">Hukum Indonesia</span> <br />
              dengan Cermat.
            </h1>

            <p className="text-fluid-sm md:text-fluid-base text-neutral-600 leading-relaxed mb-6 md:mb-8 max-w-xl">
              Tinggalkan pencarian manual dan tradisi bolak-balik membaca aturan perubahan. Justiso
              menggabungkan database hukum dengan sistem pemetaan relasi dokumen untuk memberikan
              riset yang akurat, tervisualisasi, dan siap pakai.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <button
                onClick={() =>
                  window.open(
                    'https://wa.me/6282313436274?text=Halo%2C%20saya%20tertarik%20untuk%20demo%20Justisio%20untuk%20perusahaan%20kami.',
                    '_blank'
                  )
                }
                className="group inline-flex items-center justify-center gap-2 px-4 py-2 bg-transparent text-neutral-900 border-2 border-neutral-900 text-sm font-semibold rounded-lg hover:bg-neutral-100 shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] transition-all duration-200 w-full sm:w-auto"
              >
                Jadwalkan Demo
                <ArrowUpRight
                  size={16}
                  className="text-neutral-500 group-hover:text-neutral-900 transition-colors"
                />
              </button>
            </div>
          </div>

          {/* Right Side: Visual arrangement */}
          <div className="relative h-[250px] md:h-[400px] lg:h-[450px] w-full overflow-hidden mb-4 lg:mb-0">
            {/* Main big image */}
            <div className="absolute right-0 top-1/2 -translate-y-1/2 w-full md:w-[90%] bg-white rounded-2xl overflow-hidden z-10 shadow-lg">
              <Image
                src="/static/images/landing/hero/jakarta-cityscape-1200.webp"
                alt="Pemandangan kota Jakarta yang menampilkan gedung-gedung pencakar langit modern, merepresentasikan lingkungan bisnis dan hukum Indonesia"
                width={1200}
                height={900}
                sizes="(max-width: 768px) 100vw, 85vw"
                className="w-full h-[250px] md:h-[350px] object-cover grayscale-[0.2] md:scale-105"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
